

import React from "react";

import fields from "../../json/FoodPackageFields.json";

import FormInput from "Common/Custom/FormInput";

import FormSubmitButton from "Common/Custom/FormSubmitButton";

import PageBody from "Common/Custom/PageBody";

import { HeadingOne } from "Common/Custom/HeadingOne";

import FormTextarea from "Common/Custom/FormTextarea";

import PropTypes from "prop-types";



const AddFoodPakageForm = ({

    values = {},

    errors = {},

    handleChange = () => { },

    handleSubmit,

    loading = false,

}) => {

    const { formdata } = fields;

    return (

        <PageBody onSubmit={handleSubmit} headerchildren={

            <HeadingOne>Create Food Package</HeadingOne>

        }>

            {formdata.map((field) => {

                if (field.type === "textarea") {

                    return (

                        <FormTextarea

                            key={field.name}

                            field={field}

                            value={values[field.name]}

                            handleChange={handleChange}

                            error={errors[field.name]}

                        />

                    );

                }



                return (

                    <FormInput

                        key={field.name}

                        field={field}

                        value={values[field.name]}

                        handleChange={handleChange}

                        error={errors[field.name]}

                    />

                );

            })}



            <FormSubmitButton

                label="Create"

                loading={loading}

                colSize="col-12"

                align="end"

            />

        </PageBody>

    );

};



AddFoodPakageForm.propTypes = {

    values: PropTypes.object,

    errors: PropTypes.object,

    handleChange: PropTypes.func,

    handleSubmit: PropTypes.func,

    loading: PropTypes.bool,

};



AddFoodPakageForm.defaultProps = {

    values: {},

    errors: {},

    handleChange: () => { },

    handleSubmit: () => { },

    loading: false,

};



export default AddFoodPakageForm;

